var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TableBody, TableCell, TableRow } from '@mui/material';
var BaseTableLoading = function (props) {
    var columns = props.columns, hasCheckBox = props.hasCheckBox, ordinalNumber = props.ordinalNumber;
    return (_jsx(TableBody, { children: Array.from({ length: 10 }).map(function (_, index) { return (_jsxs(TableRow, { children: [hasCheckBox && (_jsx(TableCell, { padding: 'checkbox', children: _jsx("div", { className: 'animate-pulse p-[11px]', children: _jsx("div", { className: 'w-[19px] h-[19px] bg-gray-200 rounded-sm dark:bg-gray-700' }) }) })), ordinalNumber && _jsx(TableCell, { children: index + 1 }), columns.map(function (headCell) { return (_jsx(TableCell, { sx: __assign({}, (headCell.customStyle && __assign({}, headCell.customStyle))), children: _jsx("div", { className: 'w-full animate-pulse', children: _jsx("div", { className: 'h-[25px] w-full bg-gray-200 rounded-sm dark:bg-gray-700' }) }) }, headCell.id)); })] }, "table_row_".concat(index))); }) }));
};
export default BaseTableLoading;
